import { useMediaQuery, Box } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { createContext } from 'react';
import AppRouter from '../routers/AppRouter'



export const LayoutContext = createContext({
    isMobile: false
});

const UI = () => {

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <>
            <LayoutContext.Provider value={{ isMobile }}>
                <BrowserRouter>
                    
                    <Box
                        display="flex"
                        flexDirection="column"
                        minHeight="100vh"
                        justifyContent="space-between"
                        alignItems="stretch"
                    >
                        <AppRouter />
                    </Box>


                </BrowserRouter>
            </LayoutContext.Provider>
        </>
    );
};

export default UI;